module.exports = __webpack_public_path__ + "img/login.a976b967.png";